<!-- <p>incident-detail works!</p> -->
<mat-divider></mat-divider>
<div
  [ngClass]="{
    'visitor-detail-wrapper':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'visitor-detail-wrapper-mobile': screenSize == ScreenType.Mobile
  }"
>
  <mat-card
    class="visitor-detail-card"
    [ngStyle]="
      screenSize == ScreenType.Tablet && false ? { width: '980px' } : null
    "
  >
    <mat-card-header class="visitor-detail-card-header">
      {{
        (isComplainOrClaim
          ? complainDetail.complainSubject
          : isService || incidentDetail?.isRequest == 1
          ? "Request"
          : "Incident") + " Details" | uppercase
      }}
      <button mat-mini-fab (click)="onClose()">
        <mat-icon>clear</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content class="visitor-detail-card-content">
      <form [formGroup]="showIncidentDetailsForm">
        <mat-grid-list
          [cols]="screenSize == ScreenType.Mobile ? 1 : 4"
          rowHeight="100px"
          [gutterSize]="'15px'"
        >
          <mat-grid-tile
            [rowspan]="
              screenSize == ScreenType.Mobile && isIncidentDescription
                ? 13
                : screenSize == ScreenType.Mobile
                ? 12
                : 10
            "
            [colspan]="
              isMultipleEvidence ||
              isUpdateIncident ||
              isMultipleIncidentEvidence ||
              screenSize == ScreenType.Mobile
                ? 1
                : 2
            "
          >
            <div class="internalMatGrid">
              <mat-grid-list
                [cols]="screenSize == ScreenType.Mobile ? 1 : 2"
                rowHeight="85px"
              >
                <mat-grid-tile
                  [rowspan]="screenSize == ScreenType.Mobile ? 2 : 3"
                  [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
                >
                  <div class="visitor-image">
                    <img
                      *ngIf="isImage"
                      [src]="evidence"
                      alt="No Event Evidence"
                    />
                    <!-- <pdf-viewer
                      *ngIf="isPdf"
                      [src]="evidence"
                      [rotation]="0"
                      [original-size]="false"
                      [show-all]="true"
                      [fit-to-page]="false"
                      [zoom]="1"
                      [zoom-scale]="'page-width'"
                      [stick-to-page]="false"
                      [render-text]="true"
                      [external-link-target]="'blank'"
                      [autoresize]="true"
                      [show-borders]="false"
                      style="width: 100%; height: 220px"
                    ></pdf-viewer>
                    <app-excel-handler
                      *ngIf="!isPdf && !isImage && !isDoc"
                      [fileUrl]="evidence"
                      (dataLoaded)="onDataLoaded($event)"
                      style="width: 100%; height: 100%"
                    >
                    </app-excel-handler>
                    <app-word-file-handler *ngIf="isDoc" [docxUrl]="evidence">
                    </app-word-file-handler> -->
                  </div>
                </mat-grid-tile>
                <mat-grid-tile
                  [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
                >
                  <div class="button-tile">
                    <button
                      [disabled]="!evidence"
                      (click)="onClicktoZoom()"
                      mat-raised-button
                    >
                      Click to Zoom
                    </button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Id</mat-label
                    >
                    <input
                      readonly
                      matInput
                      formControlName="incidentId"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  *ngIf="
                    !isUpdateIncident ||
                    isComplainOrClaim ||
                    isService ||
                    incidentDetail?.isRequest == 1
                  "
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Name</mat-label
                    >
                    <input
                      readonly
                      formControlName="incidentName"
                      matInput
                      [disabled]="
                        isComplainOrClaim ||
                        isService ||
                        incidentDetail?.isRequest == 1
                      "
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  *ngIf="
                    isUpdateIncident &&
                    !(
                      isComplainOrClaim ||
                      isService ||
                      incidentDetail?.isRequest == 1
                    )
                  "
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Incident Name</mat-label>
                    <mat-select formControlName="incidentName">
                      <mat-option
                        *ngFor="let option of incidentOptions"
                        [value]="option"
                      >
                        {{ option }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field></mat-grid-tile
                >
                <mat-grid-tile *ngIf="isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Type</mat-label
                    >
                    <mat-select formControlName="incidentType">
                      <mat-option value="MANUAL">Manual</mat-option>
                      <mat-option value="AUTOMATIC">Automatic</mat-option>
                    </mat-select>
                  </mat-form-field></mat-grid-tile
                >
                <mat-grid-tile *ngIf="!isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Type</mat-label
                    >
                    <input
                      readonly
                      formControlName="incidentType"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile *ngIf="!isIncidentDescription || true"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <input
                      *ngIf="viewIncident != null"
                      matInput
                      [value]="viewIncident"
                    />
                    <input
                      *ngIf="viewIncident == null"
                      readonly
                      formControlName="incidentLocation"
                      matInput
                    />
                    <mat-label>Location</mat-label>
                    <mat-icon
                      *ngIf="isUpdateIncident"
                      matSuffix
                      (click)="onClickOpenMap()"
                      >open_in_new</mat-icon
                    >
                  </mat-form-field></mat-grid-tile
                >
                <mat-grid-tile *ngIf="isIncidentDescription" rowspan="2"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <!-- <input
                      readonly
                      formControlName="incidentDescription"
                      matInput
                    /> -->
                    <textarea
                      [readonly]="!isUpdateIncident"
                      formControlName="incidentDescription"
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="3"
                      cdkAutosizeMaxRows="4"
                      matInput
                    ></textarea>
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Description</mat-label
                    >
                  </mat-form-field></mat-grid-tile
                >
                <mat-grid-tile *ngIf="isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Source</mat-label>
                    <mat-select formControlName="sourceAssetId">
                      <mat-option
                        *ngFor="let asset of orgAssetList; let i = index"
                        [value]="asset.assetId"
                        >{{ asset.assetName | titlecase }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="!isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Source</mat-label>
                    <input
                      readonly
                      matInput
                      formControlName="sourceAsset"
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile *ngIf="!isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Status</mat-label
                    >
                    <input
                      readonly
                      matInput
                      formControlName="incidentStatus"
                    /> </mat-form-field
                ></mat-grid-tile>

                <mat-grid-tile *ngIf="isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Status</mat-label
                    >

                    <mat-select
                      formControlName="incidentStatus"
                      (selectionChange)="onStatusChange($event)"
                    >
                      <mat-option *ngIf="!isAssignedToMe" value="0"
                        >Open</mat-option
                      >
                      <mat-option value="1">Close</mat-option>
                      <mat-option value="2">Verified</mat-option>
                      <mat-option *ngIf="!isAssignedToMe" value="3"
                        >Snooze</mat-option
                      >
                      <mat-option value="4">In-progress</mat-option>
                      <mat-option value="5">On-hold</mat-option>
                      <mat-option *ngIf="!isAssignedToMe" value="6"
                        >Approved</mat-option
                      >
                      <mat-option *ngIf="!isAssignedToMe" value="7"
                        >Rejected</mat-option
                      >
                      <mat-option value="8">Completed</mat-option>
                    </mat-select>
                  </mat-form-field></mat-grid-tile
                >
                <mat-grid-tile
                  *ngIf="statusError"
                  [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
                >
                  <div class="error-message">
                    {{ statusError }}
                  </div>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Priority</mat-label
                    >
                    <mat-select formControlName="incidentCriticality">
                      <mat-option value="High">High</mat-option>
                      <mat-option value="Medium">Medium</mat-option>
                      <mat-option value="Low">Low</mat-option>
                    </mat-select>
                  </mat-form-field></mat-grid-tile
                >
                <mat-grid-tile *ngIf="!isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label
                      >{{
                        isComplainOrClaim
                          ? complainDetail.complainSubject
                          : isService || incidentDetail?.isRequest == 1
                          ? "Request"
                          : "Incident"
                      }}
                      Priority</mat-label
                    >
                    <input
                      readonly
                      formControlName="incidentCriticality"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile *ngIf="isShowReporter"
                  ><mat-form-field
                    *ngIf="!isUpdateIncident"
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Reporter</mat-label>
                    <input readonly formControlName="eventCreatedBy" matInput />
                  </mat-form-field>
                  <mat-form-field
                    *ngIf="isUpdateIncident"
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Select Reporter</mat-label>
                    <input
                      matInput
                      [formControl]="hostFilter"
                      [matAutocomplete]="auto"
                      (focus)="onInputhostFilterClick()"
                    />
                    <mat-autocomplete
                      (optionSelected)="hostSelect($event)"
                      #auto="matAutocomplete"
                    >
                      <mat-option
                        *ngFor="let host of filteredUserList"
                        [value]="host.firstname + ' ' + host.lastname"
                      >
                        {{ host.firstname + " " + host.lastname }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="!isUpdateIncident"
                  ><mat-form-field
                    subscriptSizing="dynamic"
                    appearance="outline"
                  >
                    <mat-label>Assignee</mat-label>
                    <input
                      readonly
                      formControlName="assignedTo"
                      matInput
                    /> </mat-form-field
                ></mat-grid-tile>
                <mat-grid-tile
                  [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
                  *ngIf="isUpdateIncident"
                >
                  <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>Select Assign* </mat-label>
                    <input
                      matInput
                      [formControl]="selectedUsersControl"
                      [matAutocomplete]="autoAdmin"
                      (focus)="onInputselectedUsersControlClick()"
                    />
                    <mat-icon
                      style="background-color: transparent; color: #e93578"
                      matSuffix
                      (click)="clearInputField()"
                      >clear</mat-icon
                    >
                    <mat-autocomplete
                      (optionSelected)="addUser($event)"
                      #autoAdmin="matAutocomplete"
                    >
                      <mat-option
                        *ngFor="let host of filteredUserList"
                        [value]="host.firstname + ' ' + host.lastname"
                      >
                        <img
                          class="visitor-img"
                          [src]="host.profilePicture"
                          height="30"
                          width="36"
                        />
                        <span> {{ host.firstname + " " + host.lastname }}</span>
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </mat-grid-tile>
                <mat-grid-tile
                  [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
                  *ngIf="usersTemp.length > 0 && isUpdateIncident"
                >
                  <div class="selected-users">
                    <mat-chip
                      *ngFor="let user of usersTemp"
                      [removable]="true"
                      (removed)="removeUser(user)"
                    >
                      {{ user }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </div>
                </mat-grid-tile>

                <mat-grid-tile *ngIf="!isOnlyView">
                  <div class="button-tile">
                    <button
                      *ngIf="!isUpdateIncident"
                      (click)="onEdit()"
                      mat-raised-button
                    >
                      Edit
                    </button>
                    <button
                      *ngIf="isUpdateIncident"
                      [disabled]="false"
                      (click)="onUpdate()"
                      mat-raised-button
                    >
                      Update
                    </button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="!isOnlyView">
                  <div class="button-tile">
                    <button (click)="onRemoveIncident()" mat-raised-button>
                      Remove
                    </button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="!isOnlyView">
                  <div class="button-tile">
                    <button (click)="onClose()" mat-raised-button>Close</button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="isRecuringIncident">
                  <div class="button-tile">
                    <button
                      [disabled]="!isSameReporter"
                      (click)="onStopAutoAssignement()"
                      mat-raised-button
                    >
                      stop Auto Assignment
                    </button>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile *ngIf="isTimeline && !isOnlyView">
                  <div class="button-tile">
                    <button (click)="onShowTimeline()" mat-raised-button>
                      <mat-icon *ngIf="!isShowTime">add</mat-icon>
                      <mat-icon *ngIf="isShowTime">remove</mat-icon>
                    </button>
                    <!-- <input [readonly]="true" matInput value="View Timeline" />
                    <button (click)="onShowTimeline()" mat-icon-button matSuffix>
                      <mat-icon>{{ !isShowTime ? "add" : "remove" }}</mat-icon>
                    </button> -->
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            *ngIf="incidentDetail"
            style="overflow: visible"
            [colspan]="screenSize == ScreenType.Mobile ? 1 : 2"
            [rowspan]="screenSize == ScreenType.Mobile ? 12 : 9"
          >
            <div class="internalMatGridAssetTable">
              <div
                class="details-graph-wrapper"
                [ngStyle]="screenSize != ScreenType.Mobile ? {} : {}"
              >
                <app-incidents-timeline-graph-container
                  [incidentData]="incidentDetail"
                  [orgUsersData]="usersList"
                  [isGraph]="true"
                  (closeIncidentDetail)="onClose()"
                ></app-incidents-timeline-graph-container>
              </div>
              <div
                class="details-graph-wrapper"
                [ngStyle]="screenSize != ScreenType.Mobile ? {} : {}"
              >
                <app-incidents-timeline-graph-container
                  [incidentData]="incidentDetail"
                  [orgUsersData]="usersList"
                  [selectedCommentId]="selectedCommentId"
                  [isGraph]="false"
                  (closeIncidentDetail)="onClose()"
                  (postIncidentComment)="onPostIncidentComment($event)"
                ></app-incidents-timeline-graph-container>
              </div>
              <div *ngIf="screenSize == ScreenType.Mobile" style="width: 100%">
                <!-- <div
                  class="multiple-evidence-section"
                  *ngIf="isMultipleEvidence"
                >
                  <div class="evidence-header">Uploaded Files</div>
                  <div class="evidence-content-wrapper">
                    <div
                      class="evidence-content"
                      *ngFor="let evidence of complainEvidence; let i = index"
                    >
                      <div class="left-side-content">
                        <b>{{ i + 1 }}.</b> &nbsp;{{
                          evidence.FileName.split(".")[0]
                            | truncateCase
                              : (screenSize == ScreenType.Mobile ? 10 : 10)
                        }}
                      </div>
                      <div class="right-side-content">
                        <button mat-mini-fab (click)="onShowEvidence(evidence)">
                          <mat-icon>touch_app</mat-icon>
                        </button>
                        <button mat-mini-fab (click)="onDownload(evidence)">
                          <mat-icon>file_download</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div> -->
                <!-- <div
                  class="multiple-evidence-section"
                  *ngIf="isMultipleIncidentEvidence"
                >
                  <div class="evidence-header">Uploaded Files</div>
                  <div class="evidence-content-wrapper">
                    <div
                      class="evidence-content"
                      *ngFor="let evidence of incidentEvidence; let i = index"
                    >
                      <div class="left-side-content">
                        <b>{{ i + 1 }}.</b> &nbsp;{{
                          evidence.FileName.split(".")[0] | truncateCase : 10
                        }}
                      </div>
                      <div class="right-side-content">
                        <button mat-mini-fab (click)="onShowEvidence(evidence)">
                          <mat-icon>touch_app</mat-icon>
                        </button>
                        <button mat-mini-fab (click)="onDownload(evidence)">
                          <mat-icon>file_download</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div
                  class="multiple-evidence-section"
                  *ngIf="selectedMultipleAttachment.length > 0"
                >
                  <div class="evidence-header">Selected Files</div>
                  <div class="evidence-content-wrapper">
                    <div
                      class="evidence-content"
                      *ngFor="
                        let evidence of selectedMultipleAttachment;
                        let i = index
                      "
                    >
                      <div class="left-side-content">
                        <b>{{ i + 1 }}.</b> &nbsp;{{
                          evidence.attachedContentName.split(".")[0]
                            | truncateCase
                              : (screenSize == ScreenType.Mobile ? 15 : 30)
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="button-tile-onclick-zoom" *ngIf="isUpdateIncident">
                  <div class="attachment-wrapper">
                    <div
                      class="attachment-uploaded-content"
                      *ngIf="selectedMultipleAttachment.length > 0 && false"
                    >
                      <ng-container
                        *ngFor="
                          let file of selectedMultipleAttachment;
                          let i = index
                        "
                      >
                        <div class="attachment-name">
                          <p>
                            <b
                              >{{ i + 1 + "." }} &nbsp;{{
                                file.attachedContentName | truncateCase : 12
                              }}</b
                            >
                          </p>
                        </div>
                      </ng-container>
                      <ng-container
                        *ngIf="selectedMultipleAttachment.length == 0"
                      >
                        <div
                          class="attachment-name"
                          style="justify-content: center"
                        >
                          <p>
                            <b>{{ "Upload" }}</b>
                          </p>
                        </div>
                      </ng-container>
                    </div>
                    <button
                      type="button"
                      (click)="fileInput1.click()"
                      mat-raised-button
                    >
                      {{
                        selectedMultipleAttachment.length > 0
                          ? "Add More"
                          : "Upload Files"
                      }}
                    </button>
                    <input
                      type="file"
                      #fileInput1
                      style="display: none"
                      accept=".pdf,.jpeg,.png,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      multiple
                      (change)="onAttachmentSelected($event)"
                    />
                  </div>
                </div>
                <div
                  class="button-tile-onclick-zoom"
                  *ngIf="screenSize == ScreenType.Mobile"
                >
                  <button
                    *ngIf="isUpdateIncident"
                    [disabled]="false"
                    (click)="onUpdate()"
                    mat-raised-button
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            rowspan="9"
            *ngIf="
              (isMultipleEvidence ||
                isUpdateIncident ||
                isMultipleIncidentEvidence) &&
              screenSize != ScreenType.Mobile
            "
          >
            <div class="internalMatGridAssetTable" style="padding: 10px">
              <!-- <div class="visitor-image">
                <img *ngIf="!isPdf" [src]="evidence" alt="No Event Evidence" />
                <pdf-viewer
                  *ngIf="isPdf"
                  [src]="evidence"
                  [rotation]="0"
                  [original-size]="false"
                  [show-all]="true"
                  [fit-to-page]="false"
                  [zoom]="1"
                  [zoom-scale]="'page-width'"
                  [stick-to-page]="false"
                  [render-text]="true"
                  [external-link-target]="'blank'"
                  [autoresize]="true"
                  [show-borders]="false"
                  style="width: 100%; height: 220px"
                ></pdf-viewer>
              </div> -->
              <!-- <div class="multiple-evidence-section" *ngIf="isMultipleEvidence">
                <div class="evidence-header">Uploaded Files</div>
                <div class="evidence-content-wrapper">
                  <div
                    class="evidence-content"
                    *ngFor="let evidence of complainEvidence; let i = index"
                  >
                    <div class="left-side-content">
                      <b>{{ i + 1 }}.</b> &nbsp;{{
                        evidence.FileName.split(".")[0] | truncateCase : 10
                      }}
                    </div>
                    <div class="right-side-content">
                      <button mat-mini-fab (click)="onShowEvidence(evidence)">
                        <mat-icon>touch_app</mat-icon>
                      </button>
                      <button mat-mini-fab (click)="onDownload(evidence)">
                        <mat-icon>file_download</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div> -->
              <div
                class="multiple-evidence-section"
                *ngIf="isMultipleIncidentEvidence"
              >
                <div class="evidence-header">Uploaded Files</div>
                <div class="evidence-content-wrapper">
                  <div
                    class="evidence-content"
                    *ngFor="let evidence of incidentEvidence; let i = index"
                  >
                    <div class="left-side-content">
                      <b>{{ i + 1 }}.</b> &nbsp;{{
                        evidence.FileName.split(".")[0] | truncateCase : 20
                      }}
                    </div>
                    <div class="right-side-content">
                      <mat-icon
                        [ngClass]="{ 'disabled-icon': !isUpdateIncident }"
                        (click)="
                          isUpdateIncident && onRemoveEvidence(i, evidence)
                        "
                      >
                        delete
                      </mat-icon>
                      <mat-icon (click)="onShowEvidence(evidence)"
                        >touch_app</mat-icon
                      >
                      <mat-icon (click)="onDownload(evidence)"
                        >file_download</mat-icon
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="button-tile-onclick-zoom">
                <button
                  [disabled]="!evidence"
                  (click)="onClicktoZoom()"
                  mat-raised-button
                >
                  Click to Zoom
                </button>
              </div> -->
              <!-- <div class="button-tile-onclick-zoom" *ngIf="isUpdateIncident">
                <input
                  type="file"
                  (change)="onFileSelected($event)"
                  accept="image/*"
                  style="display: none"
                  #fileInput
                />
                <button (click)="fileInput.click()" mat-raised-button>
                  Upload Evidence
                </button>
              </div> -->
              <div
                class="multiple-evidence-section"
                *ngIf="selectedMultipleAttachment.length > 0"
              >
                <div class="evidence-header">Selected Files</div>
                <div class="evidence-content-wrapper">
                  <div
                    class="evidence-content"
                    *ngFor="
                      let evidence of selectedMultipleAttachment;
                      let i = index
                    "
                  >
                    <div class="left-side-content">
                      <b>{{ i + 1 }}.</b> &nbsp;{{
                        evidence.attachedContentName.split(".")[0]
                          | truncateCase : 30
                      }}
                    </div>
                    <div
                      class="right-side-content"
                      style="justify-content: flex-end"
                    >
                      <mat-icon (click)="onRemoveSelectedEvidence(i)">
                        delete
                      </mat-icon>
                      <!-- <button mat-mini-fab (click)="onDownload(evidence)">
                        <mat-icon>file_download</mat-icon>
                      </button> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="button-tile-onclick-zoom" *ngIf="isUpdateIncident">
                <div class="attachment-wrapper">
                  <div
                    class="attachment-uploaded-content"
                    *ngIf="selectedMultipleAttachment.length > 0 && false"
                  >
                    <ng-container
                      *ngFor="
                        let file of selectedMultipleAttachment;
                        let i = index
                      "
                    >
                      <div class="attachment-name">
                        <p>
                          <b
                            >{{ i + 1 + "." }} &nbsp;{{
                              file.attachedContentName | truncateCase : 12
                            }}</b
                          >
                        </p>
                      </div>
                    </ng-container>
                    <ng-container
                      *ngIf="selectedMultipleAttachment.length == 0"
                    >
                      <div
                        class="attachment-name"
                        style="justify-content: center"
                      >
                        <p>
                          <b>{{ "Upload" }}</b>
                        </p>
                      </div>
                    </ng-container>
                  </div>
                  <button
                    type="button"
                    (click)="fileInput1.click()"
                    mat-raised-button
                  >
                    {{
                      selectedMultipleAttachment.length > 0
                        ? "Add More"
                        : "Upload Files"
                    }}
                  </button>
                  <input
                    type="file"
                    #fileInput1
                    style="display: none"
                    accept=".pdf, .jpeg, .png"
                    multiple
                    (change)="onAttachmentSelected($event)"
                  />
                </div>
              </div>

              <!-- <div *ngIf="isTimeline" class="button-tile-onclick-zoom">
                <button (click)="onShowTimeline()" mat-raised-button>
                  <mat-icon *ngIf="!isShowTime">add</mat-icon>
                  <mat-icon *ngIf="isShowTime">remove</mat-icon>
                </button>
                <!-- <input [readonly]="true" matInput value="View Timeline" />
                <button (click)="onShowTimeline()" mat-icon-button matSuffix>
                  <mat-icon>{{ !isShowTime ? "add" : "remove" }}</mat-icon>
                </button> --
              </div> -->
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </mat-card-content>
    <!-- <mat-card-actions></mat-card-actions> -->
  </mat-card>
  <br />
</div>
<!-- OnZoom Dialog Content -->
<ng-template #OnZoomDialog>
  <mat-dialog-content style="max-height: -webkit-fill-available">
    <div class="on-zoom-image">
      <div *ngIf="isPdf && !pdfLoaded" class="loading-spinner">
        <mat-spinner></mat-spinner>
      </div>
      <img
        *ngIf="isImage"
        [src]="isFile ? tempEvidence : evidence"
        alt="No Event Evidence"
      />
      <pdf-viewer
        *ngIf="isPdf"
        [src]="isFile ? tempEvidence : evidence"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="true"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false"
        (after-load-complete)="onPdfLoad()"
        style="width: 100%; height: 550px"
      ></pdf-viewer>
      <app-excel-handler
        *ngIf="!isPdf && !isImage && !isDoc"
        [fileUrl]="isFile ? tempEvidence : evidence"
        (dataLoaded)="onDataLoaded($event)"
        style="width: 100%; height: 220px"
      >
      </app-excel-handler>
      <app-word-file-handler *ngIf="isDoc" [docxUrl]="tempEvidence">
      </app-word-file-handler>
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #OnUpdateAssign>
  <h2 matDialogTitle>Updating Incident</h2>
  <mat-dialog-content
    style="display: flex; justify-content: center; align-items: center"
  >
    <!-- <i> Please wait! Notifying Assignee</i> <br /> -->
    <div class="spinner"><mat-spinner></mat-spinner></div>
  </mat-dialog-content>
</ng-template>
